import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import WelcomeScreen from './components/WelcomeScreen.vue'
import CardScreen from './components/CardScreen.vue'
import FinalFormScreen from './components/FinalFormScreen.vue'
import ClapScreen from './components/ClapScreen.vue'
import store from './store';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({canvas: true, 'canvas--dots': _unref(store).getters.screen === 'card'})
  }, [
    _createVNode(WelcomeScreen),
    _createVNode(CardScreen),
    _createVNode(FinalFormScreen),
    _createVNode(ClapScreen)
  ], 2))
}
}

})